import React from 'react';
import './UiButton.scss';

interface UiButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    outline?: boolean;
}

export function UiButton({ variant = 'primary', size, outline, children, className, ...rest }: UiButtonProps) {
    const sizeClass = size && size !== 'md' ? `ui-btn--${size}` : '';
    const variantClass = outline ? `ui-btn--outline-${variant}` : `ui-btn--${variant}`;

    const wrappedChildren = React.Children.map(children, child =>
        typeof child === 'string' || typeof child === 'number'
            ? <span>{child}</span>
            : child
    );

    return (
        <button className={`ui-btn ${variantClass} ${sizeClass} ${className || ''}`.trim()} {...rest}>
            {wrappedChildren}
        </button>
    );
}
